import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  AiFillMail,
  AiFillInstagram,
} from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import sinking from '../../Assets/DrawingMixedMedia/untitled .jpg';
import rafi from '../../Assets/SoloExhibition/1.jpg';
import mikroula from '../../Assets/GraphicStorytelling/4.jpg';
import characterThumb from '../../Assets/CharacterBasedDrawings/1.jpg';
import characterDesignThumbnail from '../../Assets/Thumbnails/verveloThumbnail.jpg';
import billy from '../../Assets/3dModelling/Billy/3DmodelBilly.jpg';

function Home2() {

  const handleEmail = () => {
    window.open('mailto:nikolettap396@gmail.com?subject=Subject&body=Body%20goes%20here');
  };

  return (
    <Container fluid className="home-about-section" id="about" style={{padding: '0px'}}>
      <Container className="container-about">
        <Row
          as={Link}
          to="/character-design"
          style={{textDecoration: 'none'}}
        >
          <Col xs={12} md={8} className="home-about-description" style={{padding: '0px', background: '#fcba03'}}>
            <div><img className="section-img" src={characterDesignThumbnail} alt="waving laundry" /></div>
            <div className="tile-description" style={{paddingTop: '6%'}}>
            Character Design
              <p style={{fontWeight: '200', paddingTop: '2%'}} />
            </div>
          </Col>
        </Row>
        <Row
          as={Link}
          to="/3d-modelling"
          style={{textDecoration: 'none'}}
        >
          <Col xs={12} md={8} className="home-about-description" style={{padding: '0px', background: '#9F76e6'}}>
            <div><img className="section-img-right" src={billy} alt="MomA Art" /></div>
            <div className="tile-description" style={{paddingTop: '6%'}}>3D Modelling</div>
          </Col>
        </Row>
        <Row
          as={Link}
          to="/illustrations"
          style={{textDecoration: 'none'}}
        >
          <Col xs={12} md={8} className="home-about-description" style={{padding: '0px', background: '#6bdcc5'}}>
            <div><img className="section-img" src={characterThumb} alt="MomA Art" /></div>
            <div className="tile-description" style={{paddingTop: '6%'}}>
              Illustrations
              <p style={{fontWeight: '200', paddingTop: '2%'}} />
            </div>
          </Col>
        </Row>
        <Row
          as={Link}
          to="/graphic-storytelling"
          style={{textDecoration: 'none'}}
        >
          <Col xs={12} md={8} className="home-about-description" style={{padding: '0px', background: '#ff585d'}}>
            <div><img className="section-img-right" src={mikroula} alt="MomA Art" /></div>
            <div className="tile-description" style={{paddingTop: '6%'}}>Graphic storytelling</div>
          </Col>
        </Row>
        <Row
          as={Link}
          to="/solo-exhibition"
          style={{textDecoration: 'none'}}
        >
          <Col xs={12} md={8} className="home-about-description" style={{padding: '0px', background: '#00afd7'}}>
            <div><img className="section-img" src={rafi} alt="MomA Art" /></div>
            <div className="tile-description" style={{paddingTop: '6%'}}>
              About Intimacy
              <p style={{fontWeight: '200', paddingTop: '2%'}}>Solo Exhibition</p>
            </div>
          </Col>
        </Row>
        <Row
          as={Link}
          to="/drawing-painting"
          style={{textDecoration: 'none'}}
        >
          <Col xs={12} md={8} className="home-about-description" style={{padding: '0px', background: '#ff8f1c'}}>
            <div><img className="section-img-right" src={sinking} alt="MomA Art" /></div>
            <div className="tile-description" style={{paddingTop: '6%'}}>Painting-Mixed Media</div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://instagram.com/nikolettappkw?igshid=YmMyMTA2M2Y="
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/nikoletta-papakonstantinou-6a402a1b6/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="sw"
                  onClick={handleEmail}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
